import React from "react";
import { graphql } from "gatsby";
import { LinkedImage } from "./LinkedImage";
import {
  KontentComponentSettings,
  KontentLinks,
  KontentRichText,
} from "../../../types";
import { formatLinks } from "../../../lib/links";
import { getMultiChoice } from "../../../lib/multichoice";

export interface LinkedImageProps extends KontentComponentSettings {
  link_configuration__link: KontentLinks;
  image: KontentRichText;
}

const LinkedImageContainer: React.FC<LinkedImageProps> = ({
  id,
  link_configuration__link,
  image,
}) => {
  const link = formatLinks(link_configuration__link.modular_content)[0];
  return <LinkedImage id={id} link={link} image={image}></LinkedImage>;
};

export default LinkedImageContainer;

export const fragmentLinkedImage = graphql`
  fragment LinkedImage on kontent_item_linked_image {
    elements {
      link_configuration__link {
        modular_content {
          ...kontentRichTextLink
        }
      }
      image {
        modular_content {
          ...kontentImage
        }
      }
    }
  }
`;
